import React from 'react'
import { Row, Col } from 'react-bootstrap'
import styled from 'styled-components'
import { device } from 'utils/device'
import nspaIcon from 'images/nspa-icon.png'
import snappIcon from 'images/snapp-icon.png'
import { navigate } from 'raviger'
import { kebabCase } from 'lodash'

const OrganizationList = ({ data, translate }) => {
  return (
    <>
      {data?.map(({ logoURL, programOrganizationName, isNspaMember }, ix) => (
        <StyledRow className="align-items-center" key={kebabCase(`${programOrganizationName}-${ix}`)}>
          <Col md={2} className="justify-content-center">
            <Image
              src={logoURL || snappIcon}
              alt={programOrganizationName}
              onClick={() => console.log('click')}
            />
          </Col>
          <OrgName
            onClick={() =>
              navigate(
                `/organization-detail-search?name=${encodeURIComponent(
                  programOrganizationName
                )}`
              )
            }
          >
            {programOrganizationName}
          </OrgName>
          {isNspaMember && (
            <Col>
              <NspaIcon src={nspaIcon} alt="" />
              <span className="font-weight-light">
                {translate('organization_nspa')}
              </span>
            </Col>
          )}
        </StyledRow>
      ))}
    </>
  )
}

const Image = styled.img`
  max-width: 70px;
  cursor: pointer;

  @media ${device.mobileL} {
    margin: 1rem;
    max-width: 70%;
    max-height: 8rem;
  }
`

const StyledRow = styled(Row)`
  border-top: 1px solid ${({ theme }) => theme.palette.grayscale[1]};
  padding: 1rem 0;
`

const NspaIcon = styled.img`
  width: 24px;
  margin-right: 0.5rem;
`

const OrgName = styled(Col)`
  cursor: pointer;
  font-weight: ${({ theme }) => theme.fonts.weight.normal};

  &:hover {
    text-decoration: underline;
  }
`

export default OrganizationList
